import React from "react";
import LineIcon from "./LineIcon";

const ConfirmationPage = ({
  guestForm,
  bookingDetails,
  selectedRoom,
  finalTotal,
  createdBooking,
  adults,
  children,
  onClose,
}) => {
  return (
    <div className="be-booking-confirmation-page">

      <div className="be-booking-confirmation-card">

        {/* =========================================================
            SUCCESS ICON
        ========================================================= */}

        <div className="be-confirmation-icon">
          <LineIcon
            type="check"
            size={38}
          />
        </div>

        {/* =========================================================
            LABEL
        ========================================================= */}

        <span className="be-small-label">
          BOOKING CONFIRMED
        </span>

        {/* =========================================================
            TITLE
        ========================================================= */}

        <h1>
          Your stay is confirmed
        </h1>

        {/* =========================================================
            MESSAGE
        ========================================================= */}

        <p>
          Thank you, {guestForm.name}.
          Your reservation has been successfully
          created.
        </p>

        {/* =========================================================
            BOOKING REFERENCE
        ========================================================= */}

        {createdBooking?.bookingId && (
          <div className="be-confirmation-number">

            <span>
              Booking reference
            </span>

            <strong>
              {createdBooking.bookingId}
            </strong>

          </div>
        )}

        {/* =========================================================
            CONFIRMATION DETAILS
        ========================================================= */}

        <div className="be-confirmation-details">

          {/* GUEST */}

          <div>
            <span>
              Guest
            </span>

            <strong>
              {guestForm.name}
            </strong>
          </div>

          {/* ROOM */}

          <div>
            <span>
              Room
            </span>

            <strong>
              {selectedRoom.name}
            </strong>
          </div>

          {/* CHECK-IN */}

          <div>
            <span>
              Check-in
            </span>

            <strong>
              {bookingDetails.checkIn}
            </strong>
          </div>

          {/* CHECK-OUT */}

          <div>
            <span>
              Check-out
            </span>

            <strong>
              {bookingDetails.checkOut}
            </strong>
          </div>

          {/* GUESTS */}

          <div>
            <span>
              Guests
            </span>

            <strong>
              {adults} Adults

              {children > 0 &&
                ` · ${children} ${
                  children === 1
                    ? "Child"
                    : "Children"
                }`}
            </strong>
          </div>

          {/* TOTAL */}

          <div>
            <span>
              Total
            </span>

            <strong>
              ₹{finalTotal.toLocaleString("en-IN")}
            </strong>
          </div>

        </div>

        {/* =========================================================
            EMAIL
        ========================================================= */}

        <div className="be-confirmation-email">

          <LineIcon
            type="mail"
            size={20}
          />

          <span>
            A confirmation email with your complete
            booking details has been sent to{" "}

            <strong>
              {guestForm.email}
            </strong>.
          </span>

        </div>

        {/* =========================================================
            DONE
        ========================================================= */}

        <button
          type="button"
          className="be-page-submit-button"
          onClick={onClose}
        >
          <span>
            Done
          </span>

          <span className="be-submit-arrow">

            <LineIcon
              type="check"
              size={18}
            />

          </span>
        </button>

      </div>

    </div>
  );
};

export default ConfirmationPage;